import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import DifficultyModal from "./Components/DifficultyModal";

export default function AdminDifficulty()
{
    const [difficulties, setDifficulties] =
        useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    const [selectedDifficulty, setSelectedDifficulty] =
        useState<any>(null);

    const loadDifficulties = async () => {

        const response =
            await api.get(
                '/difficulties'
            );

        setDifficulties(
            response.data
        );
    };

    useEffect(() => {

        loadDifficulties();

    }, []);

    const handleSave = async (
        data: FormData
    ) => {

        if (
            selectedDifficulty
        ) {

            await api.post(

                `/difficulties/${selectedDifficulty.id}?_method=PUT`,

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

        } else {

            await api.post(

                '/difficulties',

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );
        }

        setModalOpen(
            false
        );

        setSelectedDifficulty(
            null
        );

        loadDifficulties();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this difficulty?'
            )
        ) {
            return;
        }

        await api.delete(
            `/difficulties/${id}`
        );

        loadDifficulties();
    };

    const moveDifficultyUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...difficulties];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setDifficulties(
            updated
        );

        await api.post(
            '/difficulties/reorder',
            {
                difficulties:
                    updated.map(
                        (
                            difficulty,
                            position
                        ) => ({
                            id:
                            difficulty.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadDifficulties();
    };

    const moveDifficultyDown = async (
        index: number
    ) => {

        if (
            index >=
            difficulties.length - 1
        ) {
            return;
        }

        const updated =
            [...difficulties];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setDifficulties(
            updated
        );

        await api.post(
            '/difficulties/reorder',
            {
                difficulties:
                    updated.map(
                        (
                            difficulty,
                            position
                        ) => ({
                            id:
                            difficulty.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadDifficulties();
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Difficulties
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedDifficulty(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}
                >
                    Add Difficulty
                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Name
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {difficulties.map(
                    (
                        difficulty,
                        index
                    ) => (

                        <tr
                            key={
                                difficulty.id
                            }
                        >

                            <td>
                                {
                                    difficulty.name
                                }
                            </td>

                            <td>
                                {
                                    difficulty.is_active
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveDifficultyUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveDifficultyDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedDifficulty(
                                                difficulty
                                            );

                                            setModalOpen(
                                                true
                                            );

                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                difficulty.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <DifficultyModal

                    difficulty={
                        selectedDifficulty
                    }

                    onClose={() =>
                        setModalOpen(
                            false
                        )
                    }

                    onSave={
                        handleSave
                    }

                />

            )}

        </AdminLayout>

    );
}
